<div class="note-container">
  <div mat-dialog-header>
    <h5>Notes</h5>
    <mat-form-field *ngIf="hasReturn && (!isNoteReadOnly)" class="w-100">
      <textarea matInput cdkFocusInitial cdkTextareaAutosize placeholder="Add Note" [(ngModel)]="data.noteText" 
        (keydown.enter)="submit();false">
      </textarea>
    </mat-form-field>
  </div>
  <div mat-dialog-content>
    <div *ngIf="data.notes.length == 0">There are no notes to display.</div>
    <div *ngFor="let note of data.notes | sort:'lastModifiedDate':'desc'; index as i">
      <span *ngIf="note.parentNoteId == null">
        <span *ngIf="i !== 0">
          <hr />
        </span>
        <span *ngIf="note != null && note.applicationUser !=null && note.applicationUser.friendlyName !=null"
          class="noteMetadata">{{note.lastModifiedDate | date}} - {{note.applicationUser.firstName}}
          {{note.applicationUser.lastName}}:</span>
        <span *ngIf="note.applicationUser == null || note.applicationUser.friendlyName ==null" class="noteMetadata">Just
          now:</span>
        <br />
        <span>{{note.notePlain}}</span>
      </span>
      <div class="subNote" *ngFor="let childNote of data.notes">
        <span *ngIf="childNote.id == note.parentNoteId ">
          <span class="noteMetadata">{{childNote.lastModifiedDate | date}} - {{note.applicationUser.firstName}}
            {{note.applicationUser.lastName}} :</span>
          <br />
          <span>{{childNote.notePlain}}</span>
        </span>
      </div>
    </div>
  </div>
  <div mat-dialog-actions class="float-right submit-btns">
    <button mat-button class="btn btn-primary" mat-dialog-close>Close</button>
    <button *ngIf="hasReturn && (!isNoteReadOnly)" mat-button class="btn btn-success" (click)="submit()">Save</button>
  </div>

</div>
